import { Building2, DollarSign, ArrowRight } from "lucide-react";

// Case studies with ACTUAL project photos from uploaded images
const caseStudies = [
  {
    name: "Winder Townhomes",
    client: "Peachtree Property Ventures",
    units: 82,
    costPerUnit: "$9,650",
    scope: "2-bed to 3-bed conversion with new kitchens",
    description: "Converted 21 units from 2-bed to 3-bed by relocating kitchen and adding walls. Included plumbing, electrical, drywall, paint, and complete new kitchen package.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/igc2kfpo_Screenshot%202026-04-08%20at%203.36.35%E2%80%AFPM.png",
    result: "$250/month rental premium per unit"
  },
  {
    name: "Princeton Towers",
    client: "GOSource & Tredway",
    units: 120,
    costPerUnit: "$9,008",
    scope: "HUD Loan - Comprehensive Affordable Renovation",
    description: "Full interior renovation including ADA compliance upgrades for 6 units, hallway and lobby renovations, and complete common area updates.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/etirmcrl_Screenshot%202026-04-08%20at%203.37.31%E2%80%AFPM.png",
    imagePosition: "center 40%", // Adjusted to show more balanced view
    result: "4.5 months completion"
  },
  {
    name: "Greensboro Apartments",
    client: "Related",
    units: 500,
    costPerUnit: "$6,185",
    scope: "Occupied Rehab at Scale",
    description: "Full cabinet replacement, quartz countertops and backsplash, vanities, plumbing fixtures, lighting, door hardware, bath accessories, and blinds.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/h8d6wbgv_Screenshot%202026-04-08%20at%203.45.06%E2%80%AFPM.png",
    result: "2.5 units per working day"
  },
  {
    name: "Kennesaw Apartments",
    client: "GOSource & Post",
    units: 350,
    costPerUnit: "$2,796",
    scope: "Appliance Supply and Install",
    description: "Complete GE stainless package: refrigerator, range, dishwasher, OTR microwave, washer, dryer with all installation parts and equipment.",
    image: "https://customer-assets.emergentagent.com/job_altura-landing/artifacts/1zgjrswa_Screenshot%202026-04-08%20at%203.44.35%E2%80%AFPM.png",
    result: "30 units at a time"
  }
];

const CaseStudiesSection = () => {
  return (
    <section 
      id="case-studies" 
      className="section-padding bg-slate-50"
      data-testid="case-studies-section"
    >
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-cyan-600 font-semibold text-sm tracking-widest uppercase mb-4 block">
            Case Studies
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-6">
            Featured{" "}
            <span className="text-cyan-600">Projects</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            See how we've helped multifamily operators transform their properties 
            with efficient, high-quality renovations.
          </p>
        </div>

        {/* Case Studies Grid - 4 projects in 2x2 grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {caseStudies.map((study, index) => (
            <div
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-sm border border-slate-200 hover:shadow-lg transition-shadow group"
              data-testid={`case-study-${index}`}
            >
              {/* Image - using object-cover with custom position */}
              <div className="aspect-[16/10] overflow-hidden bg-slate-100">
                <img
                  src={study.image}
                  alt={study.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  style={{ objectPosition: study.imagePosition || 'center center' }}
                />
              </div>
              
              {/* Content */}
              <div className="p-6">
                {/* Client Badge */}
                <div className="text-xs font-medium text-cyan-600 mb-2 uppercase tracking-wide">
                  {study.client}
                </div>
                
                <h3 className="text-xl font-bold text-slate-900 mb-2">
                  {study.name}
                </h3>
                
                <p className="text-sm text-slate-600 mb-4 line-clamp-2">
                  {study.description}
                </p>

                {/* Stats */}
                <div className="grid grid-cols-2 gap-3 mb-4 pt-4 border-t border-slate-100">
                  <div className="flex items-center gap-2">
                    <Building2 className="w-4 h-4 text-slate-400" />
                    <span className="text-sm text-slate-600">{study.units} Units</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <DollarSign className="w-4 h-4 text-slate-400" />
                    <span className="text-sm text-slate-600">{study.costPerUnit}/unit</span>
                  </div>
                </div>

                {/* Scope */}
                <div className="text-xs text-slate-500 mb-3">
                  <span className="font-medium">Scope:</span> {study.scope}
                </div>

                {/* Result Badge */}
                <div className="inline-flex items-center gap-1 bg-cyan-50 text-cyan-700 text-xs font-medium px-3 py-1.5 rounded-full">
                  <ArrowRight className="w-3 h-3" />
                  {study.result}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesSection;
